document.addEventListener("DOMContentLoaded", function () {

    const scene = document.querySelector('a-scene#main-scene');
    scene.addEventListener('loaded', async () => {
        if (__LOG_INFO__) AppLog.info('A-Frame scene loaded');

        const rotationButtons = [
            { axis: "reset", htmlElem: document.querySelector('#main-block .rotation-container .reset') },
        ]
        const viewButtons = [
            { rotation: '90 0 0', htmlElem: document.querySelector('#main-block .rotation-container .view-1') },
            { rotation: '0 -90 -20', htmlElem: document.querySelector('#main-block .rotation-container .view-2') },
            { rotation: '20 0 0', htmlElem: document.querySelector('#main-block .rotation-container .view-3') },
        ];
        const defaultCameraPosition = { x: 0, y: 2.75, z: 2 };

        const isMarketMapOverlayActive = () => document?.body?.classList?.contains('mmap-graph');

        rotationButtons.forEach(({ axis, delta, htmlElem }) => {

            htmlElem.addEventListener("click", () => {
                if (isMarketMapOverlayActive() && axis !== "reset") {
                    return;
                }
                let target = document.querySelector('#main-block #stock-3d-cube-wrapper');
                if (!target) {
                    if (__LOG_WARN__) AppLog.warn(`[${id}] Button clicked, but no target available.`);
                    return;
                }

                const rot = target.getAttribute("rotation") || { x: 0, y: 0, z: 0 };

                if (axis === "reset") {
                    let resetRotation = '30 0 0';
                    const mmapMode = (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
                    if (isMarketMapOverlayActive()) {
                        resetRotation = mmapMode === '3d' ? '30 0 0' : '90 0 0';
                    }
                    target.setAttribute("rotation", resetRotation);
                    const rotationValues = {
                        x: parseFloat(resetRotation.split(' ')[0]),
                        y: parseFloat(resetRotation.split(' ')[1]),
                        z: parseFloat(resetRotation.split(' ')[2])
                    };
                    target.emit('update-rotation', rotationValues);

                    const camera = document.querySelector('#camera');
                    if (camera) {
                        const currentPosition = camera.getAttribute('position') || { x: 0, y: 2.75, z: 2 };
                        camera.setAttribute('position', {
                            x: 0,
                            y: 2.75,
                            z: currentPosition.z
                        });
                    }

                    setTimeout(() => {
                        const vizEl = document.querySelector('[stock-cube-visualizer]');
                        if (vizEl && vizEl.components && vizEl.components['stock-cube-visualizer']) {
                            const viz = vizEl.components['stock-cube-visualizer'];
                            const wrapper = document.querySelector('#stock-3d-cube-wrapper');
                            if (isMarketMapOverlayActive() && viz.stockBars && viz.stockBars.size > 0 && wrapper) {
                                window.hasPerformedInitialZoomFit = false;
                                if (mmapMode === '3d') {
                                    const max3DBarHeight = (window.MMAP_3D_MAX_HEIGHT !== undefined) ? window.MMAP_3D_MAX_HEIGHT : 0.3;
                                    viz.adjustChartToFitViewport(
                                        viz.stockBars,
                                        viz.heightScale,
                                        viz.maxHeightValue,
                                        max3DBarHeight,
                                        0,
                                        wrapper
                                    );
                                    viz.updateBillboards?.(true);
                                }
                            } else if (viz.stockBars && viz.stockBars.size > 0 && wrapper) {
                                viz.adjustChartToFitViewport(
                                    viz.stockBars,
                                    viz.heightScale,
                                    viz.maxHeightValue,
                                    viz.usableHeight * 0.9,
                                    viz.zeroPlane,
                                    wrapper
                                );
                            }
                        }
                    }, 50);
                } else {
                    let newRot;
                    if (axis === "x") {
                        const radY = (rot.y || 0) * Math.PI / 180;
                        const adjustedDelta = delta * Math.cos(radY);
                        newRot = { ...rot, x: (rot.x + adjustedDelta + 360) % 360 };
                    } else {
                        newRot = { ...rot, [axis]: (rot[axis] + delta + 360) % 360 };
                    }
                    
                    target.setAttribute("rotation", `${newRot.x} ${newRot.y} ${newRot.z}`);
                    target.emit('update-rotation', newRot);
                }
                scene.emit('update-billboards');

                if (window.gtag) gtag('event', `Desktop_CenterPanel_ChartRotation`);
            });
        })
        viewButtons.forEach(({ rotation, htmlElem }) => {

            htmlElem.addEventListener("click", () => {
                if (isMarketMapOverlayActive()) {
                    const mmapMode = (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : '2d') || '2d';
                    if (mmapMode !== '3d') return;
                }
                let target = document.querySelector('#main-block #stock-3d-cube-wrapper');
                if (!target) return;

                target.setAttribute("rotation", rotation);
                const rotationValues = { x: parseFloat(rotation.split(' ')[0]), y: parseFloat(rotation.split(' ')[1]), z: parseFloat(rotation.split(' ')[2]) };
                target.emit('update-rotation', rotationValues);
                scene.emit('update-rotation', rotationValues);
                scene.emit('update-billboards');

                if (window.gtag) gtag('event', `Desktop_CenterPanel_ChartRotation`);
            });
        })
    });

});


